// Single source of truth for the tower portrait spritesheet.
//
// Mirrors enemy-sprite-index.ts - the mapping was previously copy-pasted into the
// bottom-bar portrait and both codex components. Keep additions here and only here.
export const TOWER_SPRITESHEET = "/images/towers/towers-sprites.png"

// Number of 64px cells in the strip
export const TOWER_SPRITE_COUNT = 4

// Sprite cell per tower type id (left to right)
// shadowblade and shrine have no portrait in the strip yet
export const TOWER_SPRITE_INDEX: Record<string, number> = {
  archer: 0,
  barracks: 1,
  mage: 2,
  siege: 3,
}
